import React from "react";
import { Box, Flex, Text, VStack, Image, Button } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../common/constants";

const SideBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const check = (i, item) => {
    const isTrue =
      i !== 5 ? pathname.includes(item.path) : pathname.includes("/settings");
    return isTrue;
  };

  return (
    <Flex
      flexDir="column"
      justifyContent="space-between"
      position={"fixed"}
      zIndex={800}
      w="287px"
      bg="#fff"
      boxShadow="0px 4px 4px 0px #00000040"
    >
      <Box h="100vh">
        <Flex
          bg="#fff"
          pos="sticky"
          zIndex={55}
          pt="40px"
          top="0"
          justifyContent="center"
        >
          <Image
            src="/assets/logo.png"
            w="162px"
            h="57px"
            objectFit="contain"
          />
        </Flex>

        <Box pl="20px" w="full">
          <Box mt="60px">
            {adminRoutes?.map((item, i) => {
              return (
                <VStack
                  key={i}
                  align="stretch"
                  mb="20px"
                  className={!check(i, item) && "parent_nav"}
                  gap={0}
                >
                  <Flex
                    align="center"
                    p={2}
                    pt={3}
                    cursor="pointer"
                    onClick={() => navigate(item.path)}
                    bg={check(i, item) ? "#01ACF0" : "transparent"}
                    borderLeftRadius={check(i, item) ? "40px" : "none"}
                    fontWeight={check(i, item) ? "700" : "500"}
                    color={check(i, item) ? "#fff" : "#B3B9C4"}
                    _hover={{
                      bg: "#01ACF0",
                      color: "#fff",
                      borderLeftRadius: "40px",
                    }}
                    h="45px"
                    transition=".3s ease-in-out"
                    position="relative"
                    gap="24px"
                    pl="30px"
                  >
                    <Box className="hovered_image">{item.sec}</Box>

                    <Box className="initial_image">
                      {check(i, item) ? item.sec : item.icon}
                    </Box>
                    <Box>
                      <Text fontSize="14px" className="hovered_text">
                        {item.name}
                      </Text>
                    </Box>
                  </Flex>
                </VStack>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default SideBar;
